/**
 * SKU-overhead annotations store fontSize either in SVG units or in the legacy 8-72 scale that assumed a
 * 0.08 factor. Blueprint-page annotations store raw page px and must NOT be passed through this.
 * A style run's fontSize uses the same unit as its annotation's own fontSize, so it normalizes identically.
 */
export const normalizeAnnotationFontSize = (fontSize: number): number => (fontSize > 8 ? fontSize * 0.08 : fontSize);
